module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/vip-icons-04-82dd7842341a9a1b16c13e64204c5f65.png";